import script from "./VideoCardContent.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoCardContent.vue?vue&type=script&setup=true&lang=js"

import "./VideoCardContent.vue?vue&type=style&index=0&id=e6bf9bb4&lang=scss&scoped=true"

import exportComponent from "/Users/pontiroli/Desktop/Repositories/eni/dist/eni-dist-eni-for-2022-hub-e-longform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6bf9bb4"]])

export default __exports__